import { Col, Row, Table } from "antd"
import moment from "moment"

export const MeasurementDataTable = (props) => {
    // console.log(props.data);
    const columns = [
        {
            title: 'Date',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, data) => <p className="mb-0">{text?.split('T')[0]}</p>
        },
        {
            title: 'Time',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, data) => <p className="mb-0"> {moment(text).format("hh:mm:ss a")} </p>
        },
        // {
        //     title: 'Type',
        //     dataIndex: 'unitType.name',
        //     key: 'unitType',
        // },
        {
            title: 'Value',
            dataIndex: ['value', 'measurement_unit'],
            key: 'value',
            defaultSortOrder: 'ascend',
            // render: (text, record) => <p className="mb-0">{record.value} {record.unitType.name}</p>,
            render: (text, record) => <p className="mb-0">{console.log(parseFloat(record?.value).toFixed(2))} {parseFloat(record?.value).toFixed(2)} {record?.measurement_unit}</p>,
            sorter: (a, b) => a.value - b.value,
        },
    ]
    return (
        <Row>
            <Col span={24}>
                <Table
                    rowKey="id"
                    columns={columns}
                    dataSource={props?.data}
                    pagination={false}
                    scroll={{ x: "max-content" }}
                    className="w-100"
                />
            </Col>
        </Row>
    )
}

